
		import async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function(require) {
				cb(require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js"));
			}, "route-system");
		}

		export default async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/system/index.js
// module id = rTh1
// module chunks = 6